import Vue from 'vue';
import Vuex from 'vuex';
import { getFoods, addFood } from '../services/foods'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    foods: [],
    // foods: [
    //   {
    //     name: 'Chicken Wings',
    //     frozen: true,
    //     temp: 375,
    //     duration: 30,
    //   },
    //   {
    //     name: 'Toasted Ravioli',
    //     frozen: true,
    //     temp: 360,
    //     duration: '7',
    //     notes: 'Check for and remove any puffy ravioli around 6 minutes',
    //   },
    //   {
    //     name: 'Bacon',
    //     frozen: false,
    //     temp: 400,
    //     duration: '10',
    //   },
    //   {
    //     name: 'Hamburgers',
    //     frozen: true,
    //     temp: 400,
    //     duration: '15 - 20',
    //   },
    //   {
    //     name: 'French Fries',
    //     frozen: true,
    //     temp: 375,
    //     duration: '14 - 16',
    //   },
    //   {
    //     name: 'Chicken Patties',
    //     frozen: true,
    //     temp: 400,
    //     duration: '11',
    //   },
    // ],
  },
  mutations: {
    addFoodToList(state, food) {
      state.foods.push(food);
    },
    loadFoods(state, foods) {
      state.foods = foods
    }
  },
  actions: {
    async addFood({ commit }, food) {
      const foodResponse = await addFood(food)
      if (foodResponse.data.success) {
        commit('addFoodToList', foodResponse.data.data);
      }
    },
    async getFoods({ commit }) {
      const foodResponse = await getFoods()
      if (foodResponse.data.success  && foodResponse.data.data) {
        commit('loadFoods', foodResponse.data.data)
      }
    }
  },
  modules: {},
});
